export const NAME = 'name';
export const GENERATE_NAME_AUTOMATICALLY = 'generateNameAutomatically';
export const PERIOD = 'startDate';
export const APPLICATION = 'applicationId';
export const NETWORK = 'networkId';
export const PLATFORMS = 'platformIds';
export const BRIEFS = 'briefIds';
export const PROMO_CODE = 'promoCodeId';
export const LANDING_PAGE = 'conversionPageId';
export const DESCRIPTION = 'description';

export const TOTAL_BUDGET = 'totalBudgetUsd';

export const COST_MODEL = 'costModelIds';

export const PAYOUT_RATIOS = 'payoutRatio';
export const ANDROID = 3;
export const IOS = 2;
export const PLARIUM_PLAY = 5;
export const PORTAL = 1;
export const AGENCIES = 'agencies';
export const AGENCY = 'id';
export const BUDGET = 'budgetUsd';
export const MY_TRACKER_TOKEN = 'myTrackerToken';
export const MEDIA_SOURCE = 'mediaSource';
export const ATTRIBUTION_PROVIDER_ID = 'attributionProviderId';

export const DEPENDENCIES = {
  [BRIEFS]: [APPLICATION],
  [NETWORK]: [APPLICATION],
  [PROMO_CODE]: [APPLICATION],
  [LANDING_PAGE]: [APPLICATION, PLATFORMS, NETWORK],
};
